import type { Node } from "interfaces/schemas";

interface FindNodeByIdProps {
  nodes: Node[];
  id: string;
}

export const findNodeById = ({ nodes, id }: FindNodeByIdProps): Node | null => {
  for (const node of nodes) {
    if (node.id === id) {
      return node;
    }
    if (node.nodes?.length) {
      const found = findNodeById({ nodes: node.nodes, id });
      if (found) {
        return found;
      }
    }
  }
  return null;
};
